<div class="container">
    <div #liquidPage id="liquid-page" 
        [ngClass]="$cssClasses()" 
        [innerHTML]="$content() ? ($content().structure | sanitize:'bypassSecurityTrustHtml') : ''"
        (selectedTextDirective)="handleTextSelection($event)"
        (emptySelection)="handleTextSelection()"
    ></div>

    <meta-liquid-cut *ngIf="$showCut()" 
        [liquidPage]="containerRef"
        (createdCanvasDataUrl)="createdCanvasDataUrl.emit($event)">
    </meta-liquid-cut>

    <meta-liquid-tooltip *ngIf="$tooltipCoords()" 
        [coords]="$tooltipCoords()!"
        [mode]="$tooltipMode()"
        [annotation]="$selectedAnnotation()"
        (createHighlight)="handleCreateHighlight($event)"
        (createLink)="handleCreateLink()"
        (createNote)="handleCreateNote()"
        (updateAnnotation)="handleUpdateAnnotation($event)"
        (deleteAnnotation)="deleteAnnotation.emit($event)"
        (openAnnotation)="openAnnotation.emit($event)"
    ></meta-liquid-tooltip>
</div>